var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import Enums from "../../util/Enums.js";
import { ConfigError } from "../../util/Errors.js";
import { toQueryString } from "@okta/okta-auth-js";
import { getTypedOAuthError, RecoverableError } from "../../util/OAuthErrors.js";
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function interactionCodeFlow(settings, idxResponse) {
  return __async(this, null, function* () {
    const {
      interactionCode
    } = idxResponse;
    const authClient = settings.getAuthClient();
    const transactionMeta = yield authClient.idx.getSavedTransactionMeta();
    const state = authClient.options.state || (transactionMeta === null || transactionMeta === void 0 ? void 0 : transactionMeta.state);
    const isRemediationMode = settings.get("mode") === "remediation";
    if (isRemediationMode) {
      authClient.idx.clearTransactionMeta();
    }
    const shouldRedirect = settings.get("redirect") === "always";
    if (shouldRedirect) {
      const redirectUri = settings.get("redirectUri");
      if (!redirectUri) {
        throw new ConfigError('"redirectUri" is required');
      }
      const qs = toQueryString({
        "interaction_code": interactionCode,
        state
      });
      window.location.assign(redirectUri + qs);
      return;
    }
    if (isRemediationMode) {
      settings.callGlobalSuccess(Enums.SUCCESS, {
        "interaction_code": interactionCode,
        state
      });
      return;
    }
    if (!transactionMeta) {
      throw new ConfigError("Could not load transaction data from storage");
    }
    const {
      codeVerifier
    } = transactionMeta;
    return authClient.token.exchangeCodeForTokens({
      codeVerifier,
      interactionCode
    }).then(({
      tokens
    }) => {
      settings.callGlobalSuccess(Enums.SUCCESS, {
        tokens
      });
    }).catch((err) => {
      const typedError = getTypedOAuthError(err);
      if (typedError instanceof RecoverableError && typedError.is("terminal")) {
        throw typedError;
      }
      settings.callGlobalError(err);
    }).finally(() => {
      authClient.idx.clearTransactionMeta();
    });
  });
}
export { interactionCodeFlow };
